import { render, staticRenderFns } from "./GroupDirectPaymentDetailPage.vue?vue&type=template&id=37d8b558&"
import script from "./GroupDirectPaymentDetailPage.vue?vue&type=script&lang=js&"
export * from "./GroupDirectPaymentDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d8b558')) {
      api.createRecord('37d8b558', component.options)
    } else {
      api.reload('37d8b558', component.options)
    }
    module.hot.accept("./GroupDirectPaymentDetailPage.vue?vue&type=template&id=37d8b558&", function () {
      api.rerender('37d8b558', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/directPaymentDetailPages/GroupDirectPaymentDetailPage.vue"
export default component.exports